import React from 'react';

import { ContentContainer } from '../contentComponents';
import { SectionContainer, SectionHeading } from '../sectionComponents';
import StandardFlex from '../StandardFlex';

const images1 = [
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/second-section/1-1.svg`,
    alt: 'popsql app screenshot',
    style: {
      boxShadow: 'var(--bs-header)',
      border: '1px solid #f4f4f4',
      borderRadius: '12px',
      marginLeft: '24px',
      width: '90%',
      position: 'absolute',
      top: '0',
    },
    width: 608,
    height: 271,
  },
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/second-section/1-2.svg`,
    alt: 'popsql app screenshot',
    style: {
      boxShadow: 'var(--bs-drop)',
      borderRadius: '12px',
      position: 'absolute',
      border: '1px solid #f4f4f4',
      top: '29%',
      width: '90%',
    },
    width: 645,
    height: 271,
  },
];

const images2 = [
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/second-section/2.svg`,
    alt: 'popsql app screenshot',
    style: {
      boxShadow: 'var(--bs-header)',
      border: '1px solid #f4f4f4',
      borderRadius: '12px',
    },
    width: 631,
    height: 304,
  },
];

const imagesSchedule = [
  {
    src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/features/schedule.svg`,
    alt: 'popsql app screenshot',
    style: {
      boxShadow: 'var(--bs-drop)',
      border: '1px solid #f4f4f4',
      borderRadius: '12px',
    },
  },
];

const ThirdSection = ({ heading }) => {
  return (
    <SectionContainer>
      <SectionHeading text={heading || 'Modern SQL editor'} />
      <ContentContainer className="flex">
        <StandardFlex
          heading="Visualize your data"
          subheading="Create charts right in PopSQL. No need to switch to Excel."
          images={images1}
          imagesContainerStyles={{
            height: '0',
            width: '100%',
            paddingBottom: '59.3%',
            position: 'relative',
          }}
          link={{
            text: 'Learn more',
            href: '/product/charts/',
            asPath: '/product/charts/',
          }}
          quote={{
            author: 'Peter Du',
            role: 'Data Analyst, Drop',
            logo: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/drop.svg`,
            logoHeight: 8,
            body: '"Looker has a lot of predefined functions, but PopSQL gives me more flexibility for writing SQL and visualizing it straight away".',
          }}
        />
        <div className="h-16 lg:h-40" />
        <StandardFlex
          heading="Never lose your work"
          subheading="PopSQL tracks changes so you can revert to any point in time in case you make a mistake."
          images={images2}
          link={{
            text: 'Learn more',
            href: '/product/version-history',
            asPath: '/product/version-history',
          }}
          isReverse
        />
        <div className="h-16 lg:h-40" />
        <StandardFlex
          heading="Schedule recurring queries"
          subheading="Set up alerts on important events, or schedule reports to refresh on a recurring basis."
          images={imagesSchedule}
          imagesContainerStyles={{
            height: '0',
            width: '100%',
            paddingBottom: '59.3%',
            position: 'relative',
          }}
          link={{
            text: 'Learn more',
            href: '/product/scheduled-queries/',
            asPath: '/product/scheduled-queries/',
          }}
        />
      </ContentContainer>
    </SectionContainer>
  );
};

export default ThirdSection;
